import script from "./VirtualCharacter.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualCharacter.vue?vue&type=script&setup=true&lang=js"

import "./VirtualCharacter.vue?vue&type=style&index=0&id=7f10c3ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f10c3ae"]])

export default __exports__